/** Minimal event emitter replacing the Vue-2 `new Vue()` bus. */
const listeners = {};

export const emitter = {
	on(event, fn) {
		(listeners[event] = listeners[event] || []).push(fn);
	},
	off(event, fn) {
		listeners[event] = (listeners[event] || []).filter((f) => f !== fn);
	},
	emit(event, payload) {
		(listeners[event] || []).forEach((fn) => fn(payload));
	},
};
